import React from 'react'
import PropTypes from 'prop-types'
import { Icon, Tab, TabList, TabPanel, TabStateProvider } from '@maui/elements'
import { Attachments, Comments } from './components'

export const ServiceDetailsTabs = ({ caseId, comments, customerAttachments = [], mandiantAttachments = [] }) => {
  return (
    <TabStateProvider>
      <TabList aria-label="Tabs">
        <Tab><Icon size='sm' mr='3px' name='messages'/>Comments</Tab>
        <Tab><Icon size='sm' mr='3px' name='link'/>My Uploads</Tab>
        <Tab><Icon size='sm' mr='3px' name='blank-paper'/>Mandiant Documents</Tab>
      </TabList>
      <TabPanel>
        <Comments caseId={caseId} comments={comments} />
      </TabPanel>
      <TabPanel>
        <Attachments attachments={customerAttachments || []} />
      </TabPanel>
      <TabPanel>
        <Attachments attachments={mandiantAttachments || []} canDownload={true} />
      </TabPanel>
    </TabStateProvider>
  )
}

ServiceDetailsTabs.propTypes = {
  caseId: PropTypes.string.isRequired,
  comments: PropTypes.array,
  customerAttachments: PropTypes.array,
  mandiantAttachments: PropTypes.array,
}
